
export default() =>({

        save() {
            this.$dispatch('canvasuser:save');
        },

        restart(confirmation = null) {
            if (confirmation === null) {
                this.$dispatch('confirmation:open', {
                    message: 'Você está prestes a reiniciar o template. Todas as alterações criadas serão removidas. Dseja continuar?',
                    callback: 'topnavuser:restart'
                });
                return;
            }
            this.$dispatch('canvasuser:restart');
        },

        out(confirmation = null, save = false) {
            if (confirmation === null) {
                this.$dispatch('confirmation:out', {
                    message: 'Tem certeza de que deseja sair?',
                    callback: 'topnavuser:out'
                });
                return;
            }
            this.$dispatch('canvasuser:out', save);
        }

})
